import blog1 from '../img/blogs/blog1.svg';
import blog2 from '../img/blogs/blog2.svg';
import blog3 from '../img/blogs/blog3.svg';
import blog4 from '../img/blogs/blog4.svg';
import blog5 from '../img/blogs/blog5.svg';

const blogs = [
    {
        id: 1,
        image: blog1,
        title: 'UI/UX Design Starter with Figma',
        link: 'https://www.facebook.com/Muhtasim315/',
        date: '21',
        month: 'Mar',
        year: '2020'
    },
    {
        id: 2,
        image: blog2,
        title: 'UI/UX Design Starter with Figma',
        link: 'https://www.facebook.com/Muhtasim315/',
        date: '09',
        month: 'Dec',
        year: '2019'
    },
    {
        id: 3,
        image: blog3,
        title: 'UI/UX Design Starter with Figma',
        link: 'https://www.facebook.com/Muhtasim315/',
        date: '15',
        month: 'Jun',
        year: '2018'
    },
    {
        id: 4,
        image: blog4,
        title: 'UI/UX Design Starter with Figma',
        link: 'https://www.facebook.com/Muhtasim315/',
        date: '04',
        month: 'Aug',
        year: '2020'
    },
    {
        id: 5,
        image: blog5,
        title: 'UI/UX Design Starter with Figma',
        link: 'https://www.facebook.com/Muhtasim315/',
        date: '09',
        month: 'Sep',
        year: '2019'
    },
    {
        id: 6,
        image: blog5,
        title: 'UI/UX Design Starter with Figma',
        link: 'https://www.facebook.com/Muhtasim315/',
        date: '09',
        month: 'Sep',
        year: '2019'
    },
    {
        id: 7,
        image: blog3,
        title: 'Test Blogs data1',
        link: 'https://www.facebook.com/Muhtasim315/',
        date: '09',
        month: 'Sep',
        year: '2019'
    },
    {
        id: 8,
        image: blog1,
        title: 'Test Blogs data2',
        link: 'https://www.facebook.com/Muhtasim315/',
        date: '09',
        month: 'Sep',
        year: '2019'
    }
];

export default blogs;